import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Innovacrystaonrentinpune() {



  const cardData =
  {
    keyword: 'Innova Crysta on Rent in Pune',
    heading: 'Sai Trupti Cabs: Innova Crysta on Rent in Pune',
    headingDescription: 'Sai Trupti Cabs offers premium and reliable Innova Crysta on rent in Pune, ideal for corporate travel, airport transfers, weddings, and outstation trips. Our fleet of well-maintained, air-conditioned Toyota Innova Crysta 7 seater vehicles features clean interiors, plush seating (6+1 or 7+1), and ample luggage space for a comfortable journey. Every ride is handled by a professional, background-verified chauffeur ensuring timely pickup across Pune, safe driving, and courteous service throughout your trip. We provide flexible options like per km Innova Crysta rental, hourly packages, one way taxi, and round trip bookings at transparent and affordable pricing with no hidden charges. With 24x7 online booking, instant confirmation, and dedicated customer support, Sai Trupti Cabs makes your Innova Crysta hire in Pune smooth, convenient, and completely hassle-free.',

    top: 'Top Places to Visit in Pune with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada is the crown jewel of Pune’s Maratha heritage, built in 1732 by the Peshwas as the seat of their empire. Once a magnificent seven-storey palace, its grand gates, carved teak balconies, and sprawling courtyards reflect royal elegance and political power. Though much of it was destroyed by fire, the fort’s ruins still whisper tales of valor, intrigue, and sacrifice. The evening light-and-sound show revives the Peshwa era through mesmerizing narration and music. Shaniwar Wada remains the emotional heart of Pune — where history, culture, and pride unite."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace stands as an enduring symbol of India’s freedom movement and Mahatma Gandhi’s legacy. Built in 1892 by Sultan Aga Khan III, the palace later became a place of internment for Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The tranquil gardens, memorials, and museum preserve their memories and personal belongings. Its elegant Italian arches and serene ambiance make it both a historical monument and a place of reflection. Every corner tells a story of sacrifice, resilience, and the unbreakable spirit of India’s struggle for independence."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop the rugged Sahyadri ranges, Sinhagad Fort is a timeless symbol of Maratha courage and pride. The fort gained fame after the legendary battle led by Tanaji Malusare under the command of Chhatrapati Shivaji Maharaj. Trekking up its steep slopes rewards visitors with panoramic views of the valley and Pune city. The fort’s stone walls, ancient gates, and rustic stalls serving pithla-bhakri bring history to life. Sinhagad is not just a fortress — it’s an experience of heritage, adventure, and the indomitable spirit of the Marathas."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is a fascinating 8th-century rock-cut shrine carved from basalt, dedicated to Lord Shiva. Located in the heart of Pune, it offers a peaceful escape from city noise and chaos. The circular Nandi mandapa, massive stone pillars, and unfinished sanctum reflect remarkable ancient craftsmanship. Believed to have been excavated during the Rashtrakuta dynasty, the temple’s spiritual aura attracts devotees and historians alike. Amid modern Pune’s growth, Pataleshwar stands as a reminder of its deep and timeless spiritual roots."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill rises gracefully over Pune, offering both divine blessings and breathtaking views. The temple complex atop the hill is dedicated to Lord Shiva and Goddess Parvati and was built by the Peshwas in the 18th century. Climbing its 108 stone steps is both a spiritual and meditative experience, rewarded by panoramic views of the city below. The site also houses the Peshwa Museum, which preserves rare artifacts of Maratha glory. At sunrise and sunset, Parvati Hill becomes a golden haven of peace, history, and devotion."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Dagdusheth Halwai Ganpati Temple is Pune’s most beloved spiritual landmark, drawing millions of devotees each year. The temple’s magnificent idol of Lord Ganesha, adorned with gold ornaments and fresh flowers, radiates devotion and positivity. During Ganesh Chaturthi, the entire area transforms into a festival of lights, music, and prayer. The temple also supports charitable causes, embodying the true essence of faith in action. Whether you visit for blessings or simply to soak in its energy, Dagdusheth Temple fills every heart with peace and joy."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum is a treasure house of Indian art and tradition, housing over 20,000 artifacts collected by the late Dr. Dinkar Kelkar. Its exhibits include intricate musical instruments, ancient sculptures, traditional ornaments, and everyday objects that reveal India’s creative spirit. The museum’s highlight is the replica of a 17th-century Wada — a traditional Maharashtrian mansion. Walking through its corridors feels like stepping back in time. It’s a must-visit for art lovers, history enthusiasts, and anyone seeking to rediscover India’s cultural richness."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, just 20 km from Pune, is a popular getaway surrounded by rolling hills and lush greenery. Built across the Mutha River, it serves as the city’s primary water source and a serene picnic spot for families and friends. Visitors enjoy the mesmerizing sunset reflecting off the calm waters while savoring local snacks from nearby stalls. During monsoon, the dam’s scenic charm doubles, making it a photographer’s paradise. It’s the perfect escape for those seeking peace, nature, and a cool breeze away from urban life."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Located in Koregaon Park, Osho International Meditation Resort is a tranquil oasis that attracts visitors from across the globe. Spread over lush gardens and modern Zen-inspired architecture, it offers various meditation sessions, wellness therapies and workshops on mindfulness. The serene environment encourages introspection and personal growth. Beyond being a retreat, Osho Resort reflects Pune’s cosmopolitan identity — blending spirituality, modernity, and holistic living. It’s where silence meets luxury, creating an experience that rejuvenates both body and soul."
  },
  {
    "title": "Pune Okayama Friendship Garden (Pu La Deshpande Udyan)",
    "description": "Inspired by Japan’s famous Korakuen Garden, the Pune Okayama Friendship Garden — also known as Pu La Deshpande Udyan — is an exquisite symbol of Indo-Japanese friendship. Spread across 10 acres, its winding paths, small bridges, ponds, and manicured lawns create a serene landscape ideal for relaxation and photography. The garden’s harmony between Japanese design and Indian flora makes it one of Pune’s most aesthetic green spaces. Families, nature lovers, and photographers visit to unwind amid its calming beauty and artistic symmetry."
  }
],



"services": [
  {
    "name": "Innova Crysta on Rent in Pune",
    "description": "Premium Innova Crysta rental service in Pune offering well-maintained vehicles with AC and Non-AC options, professional drivers, luggage support, and flexible pickup/drop points. Ideal for family trips, corporate travel, weddings, and outstation journeys, ensuring comfort, safety, and a hassle-free travel experience."
  },
  {
    "name": "Pune Innova Crysta Hire",
    "description": "Convenient Innova Crysta hire service in Pune with AC and Non-AC vehicles, experienced chauffeurs, luggage assistance, and flexible scheduling. Perfect for corporate trips, family outings, long-distance travel, and weddings, offering luxury, safety, and reliable transportation at affordable rates."
  },
  {
    "name": "AC Innova Crysta Pune",
    "description": "Comfortable AC Innova Crysta rental in Pune with professional drivers, luggage support, and flexible pickup/drop locations. Suitable for business trips, family travel, airport transfers, and outstation journeys, providing a cool and relaxing ride with premium interiors."
  },
  {
    "name": "Non AC Innova Crysta Pune",
    "description": "Budget-friendly Non-AC Innova Crysta hire in Pune with professional drivers, luggage assistance, and flexible pickup/drop schedules. Perfect for long-distance trips, corporate travel, or family outings, offering safe, reliable, and economical transportation without compromising comfort."
  },
  {
    "name": "Luxury Innova Crysta Pune",
    "description": "Premium luxury Innova Crysta service in Pune with top-class interiors, AC, professional chauffeurs, and luggage support. Ideal for weddings, VIP travel, corporate trips, and special occasions, providing a stylish, comfortable, and secure journey with transparent pricing."
  },
  {
    "name": "Corporate Innova Crysta Hire Pune",
    "description": "Specialized corporate Innova Crysta rental in Pune with AC vehicles, professional drivers, luggage support, and flexible schedules. Suitable for business trips, client meetings, corporate events, and team travel, ensuring punctuality, comfort, and a professional travel experience."
  },
  {
    "name": "Wedding Innova Crysta Pune",
    "description": "Luxury Innova Crysta service in Pune for weddings with AC/Non-AC options, professional drivers, luggage support, and timely pickups. Perfect for transporting family members, guests, or VIPs, offering a stylish, comfortable, and safe journey for special occasions."
  },
  {
    "name": "Outstation Innova Crysta Pune",
    "description": "Reliable outstation Innova Crysta service from Pune with AC/Non-AC vehicles, professional chauffeurs, luggage support, and flexible pickup/drop schedules. Ideal for long-distance trips, weekend getaways, and corporate travel, ensuring comfort, safety, and timely arrivals."
  },
  {
    "name": "Pune Innova Crysta One Way",
    "description": "Convenient one-way Innova Crysta service in Pune with AC/Non-AC vehicles, professional drivers, luggage assistance, and transparent pricing. Perfect for travelers needing point-to-point service, airport transfers, or long-distance drop-offs, offering a hassle-free and comfortable journey."
  },
  {
    "name": "Affordable Innova Crysta Rental Pune",
    "description": "Cost-effective Innova Crysta rental service in Pune with AC/Non-AC options, professional drivers, luggage support, and flexible pickup/drop locations. Suitable for family trips, corporate travel, and long-distance journeys, ensuring safe, reliable, and budget-friendly transportation."
  },
  {
    "name": "Innova Crysta Online Booking Pune",
    "description": "Book your Innova Crysta in Pune online instantly with secure payments, multiple vehicle options, professional drivers, and luggage assistance. Ideal for last-minute bookings, planned trips, and outstation travel, ensuring a smooth, safe, and comfortable ride."
  },
  {
    "name": "Innova Crysta Cab Service Pune",
    "description": "Reliable Innova Crysta cab service in Pune with AC/Non-AC options, professional drivers, luggage support, and flexible scheduling. Perfect for corporate travel, family outings, weddings, and outstation trips, offering safe, comfortable, and timely transportation."
  },
  {
    "name": "Pune Ertiga vs Innova Crysta Hire",
    "description": "Compare Pune Ertiga and Innova Crysta hire services for comfort, seating capacity, luggage space, and pricing. Ideal for travelers deciding between the two vehicles for corporate trips, family outings, or long-distance journeys, providing insights for the best travel choice."
  },
  {
    "name": "Innova Crysta 7 Seater Rental Pune",
    "description": "Spacious 7-seater Innova Crysta rental in Pune with AC/Non-AC options, professional drivers, luggage support, and flexible schedules. Perfect for family trips, small groups, corporate travel, and airport transfers, offering comfort, safety, and convenient travel."
  },
  {
    "name": "Premium Innova Crysta Pune",
    "description": "Premium Innova Crysta rental service in Pune with AC, top-class interiors, professional chauffeurs, luggage assistance, and flexible pickup/drop points. Ideal for weddings, VIP travel, corporate trips, and special occasions, providing a luxurious, safe, and stylish journey."
  }
],
"tableData": [
  ["Innova Crysta on Rent in Pune", "Pune Innova Crysta Hire"],
  ["AC Innova Crysta Pune", "Non AC Innova Crysta Pune"],
  ["Luxury Innova Crysta Pune", "Corporate Innova Crysta Hire Pune"],
  ["Wedding Innova Crysta Pune", "Outstation Innova Crysta Pune"],
  ["Pune Innova Crysta One Way", "Affordable Innova Crysta Rental Pune"],
  ["Innova Crysta Online Booking Pune", "Innova Crysta Cab Service Pune"],
  ["Pune Ertiga vs Innova Crysta Hire", "Innova Crysta 7 Seater Rental Pune"],
  ["Premium Innova Crysta Pune", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Innova Crysta on Rent in Pune",
    "WhyChoosedescription": "Sai Trupti Cabs  offers reliable and comfortable Innova Crysta rental services in Pune — perfect for city trips, airport transfers, outstation travel, and family outings."
  },
  {
    "WhyChooseheading": "Transparent & Competitive Fare",
    "WhyChoosedescription": "Get clear and affordable rental rates for Innova Crysta in Pune — no hidden charges, with options for hourly, daily, or long-distance rentals."
  },
  {
    "WhyChooseheading": "Flexible Rental Options",
    "WhyChoosedescription": "Hire Innova Crysta on an hourly, daily, or multi-day basis as per your travel plans and convenience."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our trained and courteous drivers ensure a safe, smooth, and timely journey within Pune or on outstation trips."
  },
  {
    "WhyChooseheading": "Pickup & Drop Flexibility",
    "WhyChoosedescription": "We provide convenient pickups and drop-offs across Pune, including airports, railway stations, hotels, and residences."
  },
  {
    "WhyChooseheading": "Clean & Well-Maintained Vehicles",
    "WhyChoosedescription": "All Innova Crysta cars are regularly serviced, sanitized, and maintained to ensure comfort and reliability during your ride."
  },
  {
    "WhyChooseheading": "24/7 Booking & Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with bookings, route planning, or any travel queries."
  },
  {
    "WhyChooseheading": "Hassle-Free Booking Process",
    "WhyChoosedescription": "Book your Innova Crysta rental in Pune easily via call, WhatsApp, or our website — with instant confirmation and prompt vehicle dispatch."
  }
]





















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Innova Crysta on rent in Pune?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Innova Crysta on rent in Pune for local trips, one-way, round trips, and outstation travel.',
  },
  {
    question: 'How can I book an Innova Crysta on rent in Pune with Sai Trupti Cabs?',
    answer: 'You can easily book an Innova Crysta in Pune through our website, mobile app, or by contacting our 24×7 customer support team for instant confirmation.',
  },
  {
    question: 'What types of trips can I take with an Innova Crysta rental in Pune?',
    answer: 'Our Innova Crysta can be hired for local travel, airport transfers, corporate trips, sightseeing tours, one-way or round trips, and outstation journeys.',
  },
  {
    question: 'Are the drivers experienced for Innova Crysta rentals in Pune?',
    answer: 'Yes, all our drivers are professional, courteous, and trained for both city and long-distance travel, ensuring a safe and comfortable journey.',
  },
  {
    question: 'Can I hire an Innova Crysta in Pune for family or group travel?',
    answer: 'Certainly. Our Innova Crysta rental service is ideal for family trips, group outings, and corporate travel, accommodating up to 7 passengers comfortably.',
  },
  {
    question: 'Is the Innova Crysta rental service available 24×7 in Pune?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 Innova Crysta rental services in Pune for your convenience and flexible scheduling.',
  },
  {
    question: 'What are the fares for Innova Crysta on rent in Pune?',
    answer: 'Fares start from approximately ₹1,800 for local trips and ₹2,500–₹3,500 for outstation or longer trips, depending on distance, duration, and travel requirements.',
  },
  {
    question: 'What payment methods are accepted for Innova Crysta rentals in Pune?',
    answer: 'We accept payments via UPI, credit/debit cards, bank transfers, and digital wallets for secure and hassle-free transactions.',
  },
  {
    question: 'What safety and hygiene measures are followed for Innova Crysta rentals in Pune?',
    answer: 'All Innova Crysta vehicles are sanitized before every trip, and our drivers follow strict safety and hygiene protocols for a secure journey.',
  },
  {
    question: 'Is customer support available during the Innova Crysta rental period in Pune?',
    answer: 'Yes, our 24×7 customer support team is available to assist you before, during, and after your Innova Crysta rental journey in Pune.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Deshpande',
    feedback: 'Hiring an Innova Crysta from Sai Trupti Cabs in Pune was seamless. The car was spacious, clean, and the driver was very professional.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Anjali Patil',
    feedback: 'Excellent Innova Crysta rental service in Pune. Comfortable ride, punctual driver, and great customer support.',
    rating: 5,
  },
];








































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Innova Crysta on Rent in Pune",
  "image": "https://saitrupticabs.com/assets/images/innova-crysta-pune.jpg",
  "description": "Sai Trupti Cabs offers Innova Crysta on rent in Pune for outstation trips, airport transfer, corporate travel, weddings and family tours. Book 7 seater luxury Innova Crysta with professional driver at affordable price per km with 24x7 online booking.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8240"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "18",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/innova-crysta-on-rent-pune",
    "itemCondition": "https://schema.org/NewCondition"
  }
};




  return (
    <div>
<Helmet>
  <title>Innova Crysta on Rent in Pune | ₹18/km Fare | Sai Trupti Cabs</title>

  <meta 
    name="description" 
    content="Book Innova Crysta on rent in Pune at ₹18/km with Sai Trupti Cabs. 7 seater luxury cab for outstation, airport, corporate travel & weddings. Safe, comfortable and 24x7 service." 
  />

  <meta 
    name="keywords" 
    content="innova crysta on rent in pune, innova crysta hire pune, innova crysta rent per km pune, 7 seater innova crysta pune, luxury innova crysta pune, innova crysta cab service pune, pune innova crysta booking, corporate innova crysta hire pune, wedding innova crysta pune, outstation innova crysta pune, airport innova crysta pune, cheap innova crysta pune, best innova crysta rental pune" 
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/48.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Innovacrystaonrentinpune;